import { Spin } from "antd";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout } from "../../../shared/components";
import { useProductById, useProducts } from "../hooks";
import {
  ProductsForm,
  ProductsGallery,
  TableProductCharacteristics,
  TableProductsRecipes,
  TableProductGroups,
} from "./productById";
import { WrapperProductById, WrapperTabNav } from "./styled";
import { TableProductPremiumCharacteristics } from "./productById/TableProductPremiumCharacteristics";
import { TableProductPremiumPreparationSteps } from "./productById/TableProductPremiumPreparationSteps";

export const ProductsById = () => {
  const {
    isUpdateProduct,
    formMethodsCreate,
    formMethodsUpdate,
    dataUpdateProduct,
  } = useProducts();
  const { isValidate } = useProductById();

  return (
    <AdminMenuLayout pageDescription="ProductsById" title="ProductsById">
      <WrapperProductById>
        {!isValidate || (isUpdateProduct && !dataUpdateProduct) ? (
          <Spin size="large" />
        ) : (
          <>
            {!isUpdateProduct && (
              <FormProvider {...formMethodsCreate}>
                <ProductsForm />
              </FormProvider>
            )}
            {isUpdateProduct && dataUpdateProduct && (
              <WrapperTabNav
                items={[
                  {
                    label: `DATOS DEL PRODUCTO`,
                    key: "1",
                    children: (
                      <>
                        <FormProvider {...formMethodsUpdate}>
                          <ProductsForm />
                        </FormProvider>
                      </>
                    ),
                  },
                  {
                    label: `GALERÍA`,
                    key: "2",
                    children: <ProductsGallery />,
                  },
                  {
                    label: `CARACT. DEL PRODUCTO`,
                    key: "3",
                    children: <TableProductCharacteristics />,
                  },
                  {
                    label: `RECETAS DEL PRODUCTO`,
                    key: "4",
                    children: <TableProductsRecipes />,
                  },
                  {
                    label: `GRUPOS DE PRODUCTOS`,
                    key: "5",
                    children: <TableProductGroups />,
                  },
                  ...(dataUpdateProduct?.premium === "true"
                    ? [
                        {
                          label: `CARACTERÍSTICAS DEL CORTE`,
                          key: "6",
                          children: <TableProductPremiumCharacteristics />,
                        },
                        {
                          label: `PASOS DE PREPARACIÓN`,
                          key: "7",
                          children: <TableProductPremiumPreparationSteps />,
                        },
                      ]
                    : []),
                ]}
              />
            )}
          </>
        )}
      </WrapperProductById>
    </AdminMenuLayout>
  );
};
